import React from "react";
import fieldPropTypes from "./field-prop-types";
import renderFields from "../screens/render-fields";

class FormRadioGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: null
    };

    this.handleCheckboxClick = props.appData.handleCheckboxClick;
  }

  componentDidMount() {
    const {
      field: { options }
    } = this.props;
    const selectedOption = options.find(element => element.selected === true);
    if (selectedOption) {
      this.setSelectedValue(selectedOption.value);
    }
  }

  setSelectedValue = value => {
    const {
      appData,
      field: { name }
    } = this.props;
    this.setState({ selectedValue: value });
    appData.handleChange({
      [name]: value
    });
  };

  handleRadioClickWrapper = optionName => {
    this.setSelectedValue(optionName);
  };

  drawAllOptions = options => {
    const { selectedValue } = this.state;
    const {
      components,
      appData,
      field: { name }
    } = this.props;

    const { Radio } = components;

    return options.map(
      ({ name: optionName, value, text, additional_fields }, index) => (
        // eslint-disable-next-line react/jsx-key
        <div className='field-radio-wrapper-web-sdk'>
          <Radio
            name={optionName}
            key={value}
            checked={value === selectedValue}
            onChange={() => this.handleRadioClickWrapper(value)}
            label={text}
            index={index}
            fieldsName={name}
          />
          {additional_fields
            ? renderFields(additional_fields, appData, components)
            : null}
        </div>
      )
    );
  };

  render() {
    const {
      field: { title, name, options },
      components
    } = this.props;

    const { Label } = components;

    return (
      <>
        {title ? <Label text={title} name={name} size='lg' /> : null}
        <div className='field-wrapper-web-sdk'>
          {this.drawAllOptions(options)}
        </div>
      </>
    );
  }
}

FormRadioGroup.propTypes = fieldPropTypes;

export default FormRadioGroup;
